import {html, type TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import {macherbusProjectVoteEvent} from "./macherbusEvents";
import {CHECKBOX_EVENT, type CheckboxEvent} from "../../page/elements/input/inputEvents";
import {ifDefined} from "lit/directives/if-defined.js";
import {UnLitElement, WithEopSlots} from "../../common/elements";


@customElement("eop-macherbus-project")
export class EopMacherbusProject extends WithEopSlots(UnLitElement) {

    @property({attribute: "project-id"})
    public projectId: string;
    @property({attribute: "image-src"})
    public imageSrc: string;
    @property({attribute: "image-alt"})
    public imageAlt: string;
    @property({attribute: "project-content-slot-name"})
    public projectContentSlotName: string;
    @property({type: Boolean, reflect: true})
    public voted: boolean;

    public constructor() {
        super();
        this.voted = false;
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.addEventListener(CHECKBOX_EVENT, this.handleCheckboxEvent);
    }

    public disconnectedCallback(): void {
        super.disconnectedCallback();
        this.removeEventListener(CHECKBOX_EVENT, this.handleCheckboxEvent);
    }

    private handleCheckboxEvent = (e: Event): void => {
        const value = (e as CheckboxEvent<boolean>).detail.inputValue;
        this.setVoted(value);
    };

    public render(): TemplateResult {
        return html`
            <div class="project-tile">
                <div class="tile-image">
                    <eop-responsive-image
                            image-src=${this.imageSrc}
                            image-alt=${this.imageAlt}
                            max-crop-threshold="0.25"
                    ></eop-responsive-image>
                </div>
                <div class="tile-non-image">
                    ${this.resolveSlot(this.projectContentSlotName)}
                    <div class="checkbox-container">
                        <eop-checkbox
                                input-id=${(this.projectId)}
                                label=""
                                aria-label=${ifDefined(this.imageAlt)}
                                ?checked=${this.voted}
                                ?required=${false}
                                ?invalid=${false}
                                ?valid=${false}
                                ?warning=${false}
                        ></eop-checkbox>
                    </div>
                </div>
            </div>
        `;
    }

    public setVoted(value: boolean): void {
        this.voted = value;
        this.dispatchEvent(macherbusProjectVoteEvent(this.projectId, value));
    }
}